import { Link, useLocation } from 'react-router-dom';
import { FileQuestion } from 'lucide-react';
import { Button } from '@/components/ui/button';

// The Base44 version queried base44.auth.me() to show an "ask the AI to build
// this page" note to admins. That note is meaningless now that you own the
// code, so it is gone and no data fetch is needed at all.
export default function PageNotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-6">
      <div className="max-w-md w-full text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-muted text-muted-foreground mb-6">
          <FileQuestion className="w-8 h-8" strokeWidth={1.5} />
        </div>

        <p className="text-6xl font-semibold tracking-tight text-muted-foreground/40">
          404
        </p>

        <h1 className="mt-4 text-2xl font-semibold tracking-tight text-foreground">
          Page not found
        </h1>

        <p className="mt-2 text-muted-foreground">
          There is nothing at{' '}
          <span className="font-medium text-foreground">{location.pathname}</span>.
        </p>

        <div className="mt-8">
          <Link to="/">
            <Button className="rounded-full px-8">Back to training</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
